// Unscored listings come back as 0 rather than null so the picker can render
// "0% Match" on every row instead of leaving gaps.
export const formatMatchScore = (score) => {
  const n = Math.round(parseFloat(score));
  return Number.isFinite(n) && n > 0 ? n : 0;
};
